var upsellDatabase, dataCurrency;

(function () {
  var announcementSlider = ".announcement--mobile-slider",
    slideshowComponent = Array.from(
      document.querySelectorAll("slideshow-component")
    ),
    announcementSliderrr = document.querySelector(
      ".announcement--mobile-slider"
    ),
    productFormUpsold = document.querySelectorAll("#productFormUpsold form"),
    logoBarSlider = document.querySelectorAll(".logo--bar__slider"),
    collectionSlider = Array.from(
      document.querySelectorAll(".featured-collection__slider")
    ),
    testimonialSlider = Array.from(
      document.querySelectorAll(".featured-testimonial__slider")
    ),
    productSlider = Array.from(
      document.querySelectorAll(".product-media--slider")
    ),
    addonSlider = document.querySelectorAll(".addon--slider"),
    contentContainer = document.querySelector("#product-grid"),
    pollingForData = false,
    acc = Array.from(document.querySelectorAll(".accordionn")),
    lnks = Array.from(document.querySelectorAll('a[href*="#"]')),
    parallaxElements = Array.from(document.querySelectorAll(".parallax")),
    viewportCheck = Array.from(document.querySelectorAll(".viewportCheck")),
    parallaxQuantity = parallaxElements.length;

  init();

  function init() {
    if (checkClass(productFormUpsold)) {
      addUpsellItem();
    }

    if (announcementSliderrr) {
      let announcementSliderr = new Splide(announcementSlider, {
        type: "loop",
        perPage: 1,
        rewind: false,
        focus: "center",
        autoplay: false,
        autoHeight: true,
        speed: 1000,
        easing: "linear",
        flickMaxPages: 1,
        updateOnMove: true,
        pagination: false,
        mediaQuery: "min",
        arrows: false,
        breakpoints: {
          990: {
            destroy: true,
          },
        },
      });

      announcementSliderr.on("mounted resized", function () {
        setTimeout(function () {
          announcement();
        }, 1000);
      });

      announcementSliderr.mount();
    }

    slideshowComponent.forEach((item) => {
      item.addEventListener("mousedown", () =>
        item.classList.add("is-pointer-down")
      );
      item.addEventListener("mouseup", () =>
        item.classList.remove("is-pointer-down")
      );

      let slideshow = new Splide(item, {
        type: "loop",
        autoplay: true,
        // rewind : true,
        pagination: true,
        // speed: 1000,
        arrows: false,
        classes: {
          pagination: "splide__pagination page-width",
          page: "splide__pagination__page",
        },
      });

      slideshow.on("dragged", () => item.classList.remove("is-pointer-down"));

      slideshow.on("visible", (slide) => {
        item
          .querySelectorAll(".splide__pagination__page")
          .forEach(
            (a) =>
              (a.style.backgroundColor = item
                .getElementsByClassName("splide__slide")
                [slide.index].getAttribute("data-color"))
          );
      });

      slideshow.mount();

      Array.from(document.querySelectorAll(".banner__box")).forEach((box) => {
        for (let i = 0; i < Array.from(box.children).length; i++) {
          Array.from(box.children)[i].style.transitionDelay = `${i / 20}s`;
        }
      });
    });

    collectionSlider.forEach((i) => {
      let xxx = new Splide(i, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        rewind: false,
        pagination: false,
        padding: { left: "2rem", right: "10%" },
        arrows: true,
        width: "100%",
        waitForTransition: true,
        wheel: false,
        gap: "1.5rem",
        easing: "linear",
        trimSpace: true,
        dragMinThreshold: {
          mouse: 100,
          touch: 20,
        },
        breakpoints: {
          989: {
            gap: "1rem",
            perPage: 2,
            perMove: 1,
            padding: { left: "2rem", right: "20%" },
          },
          749: {
            // type: 'loop',
            gap: "1rem",
            perPage: 1,
            perMove: 1,
            padding: "15%",
          },
        },
      }).mount();
      //
      // i.style.maxHeight = '';
      // i.style.overflow = '';
      // i.style.opacity = 1;
    });

    testimonialSlider.forEach(function (i) {
      new Splide(i, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        focus: "center",
        autoplay: false,
        arrows: false,
        pagination: true,
        gap: "1.5rem",
        padding: "25%",
        autoWidth: false,
        breakpoints: {
          989: {
            gap: "1rem",
            padding: "10%",
          },
          749: {
            gap: "1rem",
            padding: "1rem",
          },
        },
      }).mount();
    });

    productSlider.forEach((slider) => {
      let _slider = new Splide(slider, {
        type: "slide",
        perPage: 1,
        perMove: 1,
        rewind: false,
        autoplay: false,
        pagination: false,
        arrows: true,
        width: "100%",
        gap: "1rem",
      });

      if (
        slider.nextElementSibling &&
        slider.nextElementSibling.tagName == "SLIDER-COMPONENT"
      ) {
        let _thumbnails = new Splide(slider.nextElementSibling, {
          direction: "ttb",
          gap: ".3rem",
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: false,
          perPage: 6,
          height: "100%",
          breakpoints: {
            989: {
              direction: "ltr",
            },
          },
        });

        _slider.sync(_thumbnails);
        _slider.mount();
        _thumbnails.mount();
      } else {
        _slider.mount();
      }
    });

    addonSlider.forEach(function (i) {
      new Splide(i, {
        type: "slide",
        perPage: 2,
        perMove: 1,
        autoplay: false,
        pagination: false,
        arrows: false,
        width: "100%",
        gap: "2rem",
        breakpoints: {
          989: {
            gap: "1rem",
          },
        },
      }).mount();
    });

    logoBarSlider.forEach(function (i) {
      new Splide(i, {
        type: "slide",
        perPage: 5,
        perMove: 5,
        rewind: true,
        autoplay: true,
        updateOnMove: true,
        pagination: false,
        arrows: false,
        width: "100%",
        gap: "1rem",
        breakpoints: {
          989: {
            perPage: 4,
            perMove: 3,
            arrows: true,
            autoplay: false,
          },
          749: {
            perPage: 2,
            perMove: 1,
            arrows: true,
            autoplay: false,
          },
        },
      }).mount();
    });

    acc.forEach((accordion) => {
      var panel = accordion.nextElementSibling;
      panel.style.cssText = `--panel-height:${panel.scrollHeight}px;`;

      accordion.addEventListener("click", (event) => {
        event.target.classList.toggle("active");
      });
    });

    lnks.forEach((each) => {
      each.addEventListener("click", function (e) {
        e.preventDefault();
        const currentTarget = this.getAttribute("href");
        smoothScroll(currentTarget, 1000);
      });
    });
  }

  window.addEventListener("scroll", function (e) {
    const distToBottom = getDistFromBottom();

    var loadMore = document.querySelector("#show-more"),
      loadingButton = loadMore;

    if (
      window.innerWidth > 989 &&
      checkClass(document.querySelectorAll(".show-more:not(.noAuto-true)"))
    ) {
      var next = loadingButton
          ? loadingButton.getAttribute("data-href")
          : false,
        article = false,
        blog = false;

      if (
        !pollingForData &&
        distToBottom <
          document.body.offsetHeight - elementPos(loadingButton) - 150
      ) {
        e.preventDefault;

        if (next) {
          pollingForData = true;
          loadingButton.classList.add("loading");
          reQuest(next, loadingButton, article, blog);
        }
      }
    }

    if (
      checkClass(document.querySelectorAll(".show-more")) &&
      !pollingForData
    ) {
      document
        .getElementById("show-more")
        .addEventListener("click", function (e) {
          var $this = this,
            article = false,
            blog = false;
          if (hasClass($this, "article-load-more")) {
            article = true;
          } else if (hasClass($this, "blog-load-more")) {
            blog = true;
          }
          workMoreButton(e, $this, article, blog);
        });
    }

    var returnToTop = document.querySelector("#return-to-top");
    if (returnToTop) {
      if (
        document.documentElement.scrollTop >= 800 &&
        returnToTop.style.display === "none"
      ) {
        returnToTop.style.display = "block";
        setTimeout(function () {
          returnToTop.style.opacity = 1;
        }, 300);
      } else if (document.documentElement.scrollTop < 800) {
        returnToTop.style.opacity = 0;
        setTimeout(function () {
          returnToTop.style.display = "none";
        }, 300);
      }
    }

    // if (parallaxElements.length > 0) window.requestAnimationFrame(() => {
    //   for (let i = 0; i < parallaxQuantity; i++) {
    //     // var distToBottom = getDistFromBottom();
    //     // distToBottom < (document.body.offsetHeight - elementPos(loadingButton) - 150)
    //     const currentElement =  parallaxElements[i]
    //     const parentElement = parallaxElements[i].parentElement
    //
    //     // console.log(elementPos(parentElement));
    //
    //     const scrolled = window.scrollY
    //     // currentElement.style.transform = `translateY(${scrolled * -0.3}px)`
    //   }
    // })

    const windowHeight = window.innerHeight;

    if (parallaxElements.length > 0)
      window.requestAnimationFrame(() => {
        for (let i = 0; i < parallaxQuantity; i++) {
          const currentElement = parallaxElements[i];
          const parentElement = currentElement.parentElement;
          const parentPosition = elementPos(parentElement);

          // when top of parent element shows at bottom of window
          const parentTopPeek = document.body.offsetHeight - parentPosition;

          // when top of parent element touches top of window
          const parentTopDisappear =
            document.body.offsetHeight - parentPosition - windowHeight;

          if (
            distToBottom < parentTopPeek &&
            distToBottom - window.innerHeight > 0
          ) {
            const percentMoved =
              ((distToBottom - window.innerHeight) / parentTopDisappear) * 100;
            currentElement.style.top = `${percentMoved}%`;
          }
        }
      });

    viewportCheck.forEach((item, i) => {
      if (distToBottom < document.body.offsetHeight - elementPos(item) - 350) {
        window.requestAnimationFrame(() => {
          item.classList.add("in-viewPort");
        });
      } else {
        item.classList.remove("in-viewPort");
      }
    });
  });

  function workMoreButton(e, $this, article, blog) {
    var loadingButton = $this,
      next = loadingButton ? loadingButton.getAttribute("data-href") : false;

    if (!pollingForData && next) {
      e.preventDefault;

      pollingForData = true;
      loadingButton.classList.add("loading");
      reQuest(next, loadingButton, article, blog);
    }
  }

  function reQuest(next, loadingButton, article, blog) {
    if (next) {
      var data,
        dataObj,
        parser,
        xmlDoc,
        newNext,
        xhr = new XMLHttpRequest(),
        parser = new DOMParser();
      //           next = loadMore[0].getAttribute('data-href');

      xhr.onload = function () {
        data = xhr.responseText;

        xmlDoc = parser.parseFromString(data, "text/html");

        if (
          xmlDoc.getElementsByTagName("parsererror").length > 0 ||
          xmlDoc.querySelectorAll(".template-404").length > 0
        ) {
          console.log(
            xmlDoc.getElementsByTagName("parsererror")[0],
            xmlDoc.querySelectorAll(".template-404")[0]
          );

          //           return false;
        } else {
          var bigWrapper = "#product-grid";

          if (article) {
            bigWrapper = ".article-template__comments";
          } else if (blog) {
            bigWrapper = ".blog-articles";
          }

          newNext = xmlDoc.querySelectorAll(".show-more").length
            ? xmlDoc.querySelectorAll(".show-more")[0].getAttribute("data-href")
            : false;

          var count = xmlDoc.querySelector(bigWrapper)
            ? xmlDoc.querySelector(bigWrapper).innerHTML
            : false;
          var productCounter = xmlDoc.getElementById("ProductCount")
            ? xmlDoc.getElementById("ProductCount").innerHTML
            : false;

          if (count) {
            var grids = xmlDoc.querySelector(bigWrapper).childNodes,
              num = 1,
              gridsNum = grids.length;

            for (var x = 0; x < gridsNum; x++) {
              var grid_item = grids[x],
                para = document.createElement(grid_item.tagName);

              cloneAttributes(para, grid_item);

              if (article) {
                para.classList.add("slide-in-right");
              } else {
                para.classList.add("slide-in-bottom");
              }
              para.style.animationDelay = num * 100 - 100 + "ms";
              para.innerHTML = grid_item.innerHTML;

              document.querySelector(bigWrapper).appendChild(para);

              if (num == gridsNum) {
                pollingForData = false;
              }
              num++;
            }
          } else {
            //             pollingForData = false;
            return false;
          }

          if (!pollingForData) {
            if (!newNext) {
              loadingButton.setAttribute("data-href", false);

              document.querySelector("#load_more-container").style.opacity =
                "0";

              if (productCounter) {
                document.getElementById("ProductCount").innerHTML =
                  productCounter;
                document.getElementById("ProductCountDesktop").innerHTML =
                  productCounter;
              }

              setTimeout(function () {
                document.querySelector("#load_more-container").remove();
              }, 200);
            } else {
              loadingButton.setAttribute("data-href", newNext);
              loadingButton.classList.remove("loading");

              if (productCounter) {
                document.getElementById("ProductCount").innerHTML =
                  productCounter;
                document.getElementById("ProductCountDesktop").innerHTML =
                  productCounter;
              }
            }
          }
        }
      };
    }

    xhr.open("GET", next, true);
    xhr.send();
  }

  function getDistFromBottom() {
    var scrollPosition = window.pageYOffset,
      windowSize = window.innerHeight,
      bodyHeight = document.body.offsetHeight;
    // buttonPos = document.querySelector('#show-more').pageYOffset;

    return Math.max(bodyHeight - (scrollPosition + windowSize), 0);
  }

  function elementPos(element) {
    var rect = element.getBoundingClientRect();
    var elementLeft, elementTop; //x and y
    var scrollTop = document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    var scrollLeft = document.documentElement.scrollLeft
      ? document.documentElement.scrollLeft
      : document.body.scrollLeft;

    elementTop = rect.top + scrollTop;
    elementLeft = rect.left + scrollLeft;

    return elementTop;
  }

  function checkClass(e) {
    if (e.length) {
      return true;
    } else {
      return false;
    }
  }
})();

function smoothScroll(targetEl, duration) {
  let target = document.querySelector(targetEl);
  let targetPosition = target.getBoundingClientRect().top - 20;
  let startPosition = window.pageYOffset;
  let startTime = null;

  const ease = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const animation = function (currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, targetPosition, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  requestAnimationFrame(animation);
}

function cloneAttributes(target, source) {
  [...source.attributes].forEach((attr) => {
    target.setAttribute(attr.nodeName, attr.nodeValue);
  });
}

function removeItem(array, item) {
  for (var i in array) {
    if (array[i].id == item) {
      array.splice(i, 1);
      break;
    }
  }
}

function totalUpsellPrice(array) {
  var totallUpsell = 0;
  for (var i in array) {
    totallUpsell += parseInt(array[i].__pricce);
  }
  return numToPrice(totallUpsell);
}

function numToPrice(num) {
  parseInt(num);
  num = num / 100;

  if (num == 0) {
    return "Free";
  } else if (Number.isInteger(num)) {
    return "+" + dataCurrency + num;
  } else {
    return "+" + dataCurrency + num.toFixed(2);
  }
}

window.addEventListener("resize", announcement);

function announcement() {
  var el = document.querySelector(".shopify-section.section--announcement");
  if (!el) {
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      "0px"
    );
    return;
  }
  var h = Math.round(el.getBoundingClientRect().height);
  document.documentElement.style.setProperty(
    "--announcement-bar-height",
    `${Math.max(0, h)}px`
  );
}

document.querySelector(".quick_points") &&
  Array.from(document.querySelectorAll(".quick_points")).forEach((item) => {
    item.closest(".card-information").style.cssText = `height:${
      item.closest(".card-wrapper").clientHeight -
      item.closest(".card-wrapper").firstElementChild.clientHeight
    }px;`;

    item.closest(".card-information__container").style.position = "absolute";

    let pointsHeight = 0;
    let points = Array.from(item.children);

    points.forEach((point) => {
      pointsHeight += point.clientHeight;
    });

    item.closest(
      ".card-wrapper"
    ).style.cssText = `--pointsHeight:${pointsHeight}px;`;
    item.closest(".card-wrapper").classList.add("quick_links-active");
  });

document.querySelector(".product-tabs-button") &&
  Array.from(document.querySelectorAll(".product-tabs-button")).forEach(
    (item, i) => {
      item.addEventListener("click", () => {
        if (hasClass(item, "active")) return;

        Array.from(document.querySelectorAll(".product-tabs-button")).forEach(
          (item) => item.classList.remove("active")
        );
        Array.from(document.querySelectorAll(".product-tabs-panel")).forEach(
          (item) => (item.style.display = "none")
        );
        item.classList.add("active");
        Array.from(document.querySelectorAll(".product-tabs-panel"))[
          i
        ].style.display = "block";
      });
    }
  );

function hasClass(element, className) {
  return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
}
